import React from "react";
import { useParams } from "react-router-dom";
import { CharacterUpgrade } from "../components/CharacterUpgrade/CharacterUpgrade";
import { Page } from "../components/Page/Page";
import { DEFAULT_CHARACTER_ID } from "../scripts/game/character/Character";

export function CharacterUpgradePage(): JSX.Element {
  const { characterId } = useParams<{ characterId?: string }>();

  // Use the characterId from URL params or default
  const finalCharacterId = characterId || DEFAULT_CHARACTER_ID;

  const handleClose = () => {
    // Navigate back to stage select or main menu
    window.history.back();
  };

  return (
    <Page>
      <CharacterUpgrade characterId={finalCharacterId} onClose={handleClose} />
    </Page>
  );
}
